<script setup>
import { reactive } from 'vue';
import router from '@/router';
import RegisteringPhysician from '@/registration/RegisteringPhysician.vue';
import RegisteringBillingAgent from '@/registration/RegisteringBillingAgent.vue';

const state = reactive({
    userType: '',
})

function openRegistration(role){
    // state.userType = role;
    router.push({name: 'edit-account', params: {role: role, newAct: 'true'}});
}

</script>
<template>
    <RegisteringPhysician v-if="state.userType == 'physician'" @go-back="state.userType=''"/>
    <RegisteringBillingAgent v-else-if="state.userType == 'billingAgent'" @go-back="state.userType=''"/>

    <div v-else class="form-box">
        <div class="form-text">
            <h1>Welcome! </h1>
            <h3>Before we can get started we need to know if you are a billing agent, or physician.</h3>
        </div>

        <div class="button-container">
            <button @click="openRegistration('physician')">Physician</button>
            <button @click="openRegistration('secretary')">Secretary</button>
        </div>
    </div>
</template>
<style scoped lang="scss">

.form-text{
    display: inline-block;
    text-align: center;
    h3{
        margin-bottom: 6.25rem;
    }
}
.form-box {
    margin-top: 1rem;
    background-color: #fff;
    border-radius: 0.9375rem;
    width: 100%;
    text-align: center;

    .button-container {
        button {
            margin: 0.625rem;
            margin-bottom: 6.25rem;
            font-size: 1.5rem;
        }

    }

}

.registration-label {
    width: 10%;
}
</style>
